import type { VendorRfqLine } from "../types";

export function nextAttachmentExpiry(lines: VendorRfqLine[]): number | null {
  const expiries = lines
    .flatMap((line) => line.attachments.filter((attachment) => attachment.url && attachment.url_expires_at).map((attachment) => new Date(attachment.url_expires_at as string).getTime()))
    .filter(Number.isFinite);
  return expiries.length ? Math.min(...expiries) : null;
}
